"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFluidMaxPerformanceInput = parseFluidMaxPerformanceInput;
exports.parseExpressCalcFluidMaxPerformanceInputs = parseExpressCalcFluidMaxPerformanceInputs;
exports.parseFluidTargetTemperatureInput = parseFluidTargetTemperatureInput;
exports.parseExpressCalcFluidTargetTemperatureInput = parseExpressCalcFluidTargetTemperatureInput;
exports.parseFreonMaxPerformanceInput = parseFreonMaxPerformanceInput;
exports.parseFreonTargetTemperatureInput = parseFreonTargetTemperatureInput;
exports.parseSteamMaxPerformanceInput = parseSteamMaxPerformanceInput;
exports.parseSteamTargetTemperatureInput = parseSteamTargetTemperatureInput;
exports.parseExpressCalcPressureSteamMaxPerformanceInputs = parseExpressCalcPressureSteamMaxPerformanceInputs;
exports.parseExpressCalcTemperatureSteamMaxPerformanceInputs = parseExpressCalcTemperatureSteamMaxPerformanceInputs;
exports.parseExpressCalcHumiditySteamMaxPerformanceInputs = parseExpressCalcHumiditySteamMaxPerformanceInputs;
exports.parseExpressCalcPressureSteamTargetTemperatureInput = parseExpressCalcPressureSteamTargetTemperatureInput;
exports.parseExpressCalcTemperatureSteamTargetTemperatureInput = parseExpressCalcTemperatureSteamTargetTemperatureInput;
exports.parseExpressCalcHumiditySteamTargetTemperatureInput = parseExpressCalcHumiditySteamTargetTemperatureInput;
const property_1 = require("@genesys/property");
const uom_1 = require("@genesys/uom");
const calculations_1 = require("@munters/calculations");
const functions_1 = require("./functions");
function parseFluidMaxPerformanceInput(pvs) {
    const temperatureIn = property_1.PropertyValueSet.getAmount("airinputstemperature", pvs);
    const pressureIn = property_1.PropertyValueSet.getAmount("airinputspressure", pvs);
    const humidityIn = calculations_1.Physics.RP1485.AmountConversions.relativeHumidityToHumidityRatio(pressureIn, temperatureIn, property_1.PropertyValueSet.getAmount("airinputshumidity", pvs));
    const flow = property_1.PropertyValueSet.getAmount("airinputsairflow", pvs);
    const safetyOnSurface = property_1.PropertyValueSet.getAmount("safetyonsurface", pvs);
    const safetyOnCapacity = property_1.PropertyValueSet.getAmount("safetyoncapacity", pvs);
    return {
        temperatureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(temperatureIn)),
        humidityIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(humidityIn)),
        pressureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(pressureIn)),
        flowIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(flow)),
        safetyOnCapacity: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(safetyOnCapacity)),
        safetyOnSurface: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(safetyOnSurface)),
        geometry: parseGeometryInput(pvs, true),
        fluidComposition: parseFluidCompositionCalculateInput(pvs),
        fluidInput: parseFluidInputCalculateInput(pvs)
    };
}
function parseExpressCalcFluidMaxPerformanceInputs(pvs, stepProperty) {
    const temperatureIn = property_1.PropertyValueSet.getAmount("airinputstemperature", pvs);
    const pressureIn = property_1.PropertyValueSet.getAmount("airinputspressure", pvs);
    const humidityIn = calculations_1.Physics.RP1485.AmountConversions.relativeHumidityToHumidityRatio(pressureIn, temperatureIn, property_1.PropertyValueSet.getAmount("airinputshumidity", pvs));
    const flow = property_1.PropertyValueSet.getAmount("airinputsairflow", pvs);
    const safetyOnSurface = property_1.PropertyValueSet.getAmount("safetyonsurface", pvs);
    const safetyOnCapacity = property_1.PropertyValueSet.getAmount("safetyoncapacity", pvs);
    if (stepProperty === "temperature") {
        const temperaturesOut = (0, functions_1.getTemperaturesOut)(pvs);
        return temperaturesOut.map((t) => ({
            temperatureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(temperatureIn)),
            humidityIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(humidityIn)),
            pressureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(pressureIn)),
            flowIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(flow)),
            safetyOnCapacity: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(safetyOnCapacity)),
            safetyOnSurface: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(safetyOnSurface)),
            geometry: parseGeometryInput(pvs, true),
            fluidComposition: parseFluidCompositionCalculateInput(pvs),
            fluidInput: parseFluidInputCalculateInput(property_1.PropertyValueSet.setAmount("temperatureout", t, pvs))
        }));
    }
    else {
        const flows = (0, functions_1.getFlows)(pvs);
        return flows.map((f) => ({
            temperatureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(temperatureIn)),
            humidityIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(humidityIn)),
            pressureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(pressureIn)),
            flowIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(flow)),
            safetyOnCapacity: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(safetyOnCapacity)),
            safetyOnSurface: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(safetyOnSurface)),
            geometry: parseGeometryInput(pvs, true),
            fluidComposition: parseFluidCompositionCalculateInput(pvs),
            fluidInput: parseFluidInputCalculateInput(property_1.PropertyValueSet.setAmount("flow", f, pvs))
        }));
    }
}
function parseFluidTargetTemperatureInput(pvs) {
    const temperatureTarget = property_1.PropertyValueSet.getAmount("calculationmethodtargettemperature", pvs);
    // Target temperature SOLVES for the fluid flow, so its input type carries a
    // fluidTemperatureIn where max performance carries a whole fluidInput. Spreading the
    // max-performance shape drags fluidInput along, and TypeScript does not
    // excess-property-check a spread - so it compiles, and the server rejects the variable at
    // runtime with "Unrecognized input fields 'fluidInput'". Drop it explicitly.
    const _a = parseFluidMaxPerformanceInput(pvs), { fluidInput: _notUsedByTargetTemperature } = _a, shared = __rest(_a, ["fluidInput"]);
    return Object.assign(Object.assign(Object.assign({}, shared), parseFluidSideConstraints(pvs)), { fluidTemperatureIn: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("temperaturein", pvs)), temperatureTarget: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(temperatureTarget)) });
}
/**
 * The box the modulation may search in. The server held these hardcoded and wide open, so a
 * target-temperature calculation could settle on a tube-side velocity no supplier would build
 * for; they are inputs now, starting at the values that used to be baked in.
 */
function parseFluidSideConstraints(pvs) {
    return {
        minFluidVelocity: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("constraintsminvelocity", pvs)),
        maxFluidVelocity: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("constraintsmaxvelocity", pvs)),
        maxFluidFlow: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("constraintsmaxflow", pvs)),
        maxFluidPressureDrop: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("constraintsmaxpressuredrop", pvs))
    };
}
function parseExpressCalcFluidTargetTemperatureInput(pvs, stepProperty) {
    const temperatureTarget = property_1.PropertyValueSet.getAmount("calculationmethodtargettemperature", pvs);
    // Same as parseFluidTargetTemperatureInput above: fluidInput has no place on the
    // target-temperature input type and has to be dropped rather than spread through.
    return parseExpressCalcFluidMaxPerformanceInputs(pvs, stepProperty).map((i) => {
        const { fluidInput: _notUsedByTargetTemperature } = i, shared = __rest(i, ["fluidInput"]);
        return Object.assign(Object.assign(Object.assign({}, shared), parseFluidSideConstraints(pvs)), { temperatureTarget: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(temperatureTarget)), fluidTemperatureIn: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("temperaturein", pvs)) });
    });
}
function parseFreonMaxPerformanceInput(pvs) {
    const temperatureIn = property_1.PropertyValueSet.getAmount("airinputstemperature", pvs);
    const pressureIn = property_1.PropertyValueSet.getAmount("airinputspressure", pvs);
    const humidityIn = calculations_1.Physics.RP1485.AmountConversions.relativeHumidityToHumidityRatio(pressureIn, temperatureIn, property_1.PropertyValueSet.getAmount("airinputshumidity", pvs));
    const flow = property_1.PropertyValueSet.getAmount("airinputsairflow", pvs);
    const safetyOnSurface = property_1.PropertyValueSet.getAmount("safetyonsurface", pvs);
    const safetyOnCapacity = property_1.PropertyValueSet.getAmount("safetyoncapacity", pvs);
    return {
        temperatureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(temperatureIn)),
        humidityIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(humidityIn)),
        pressureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(pressureIn)),
        flowIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(flow)),
        safetyOnCapacity: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(safetyOnCapacity)),
        safetyOnSurface: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(safetyOnSurface)),
        geometry: parseGeometryInput(pvs, false),
        freonState: parseFreonCoilFreonStateCalculateInput(pvs)
    };
}
function parseFreonTargetTemperatureInput(pvs) {
    const temperatureTarget = property_1.PropertyValueSet.getAmount("calculationmethodtargettemperature", pvs);
    return Object.assign(Object.assign({}, parseFreonMaxPerformanceInput(pvs)), { temperatureTarget: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(temperatureTarget)) });
}
function parseSteamMaxPerformanceInput(pvs) {
    const temperatureIn = property_1.PropertyValueSet.getAmount("airinputstemperature", pvs);
    const pressureIn = property_1.PropertyValueSet.getAmount("airinputspressure", pvs);
    const humidityIn = calculations_1.Physics.RP1485.AmountConversions.relativeHumidityToHumidityRatio(pressureIn, temperatureIn, property_1.PropertyValueSet.getAmount("airinputshumidity", pvs));
    const flow = property_1.PropertyValueSet.getAmount("airinputsairflow", pvs);
    const safetyOnSurface = property_1.PropertyValueSet.getAmount("safetyonsurface", pvs);
    const safetyOnCapacity = property_1.PropertyValueSet.getAmount("safetyoncapacity", pvs);
    return {
        temperatureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(temperatureIn)),
        humidityIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(humidityIn)),
        pressureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(pressureIn)),
        flowIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(flow)),
        safetyOnCapacity: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(safetyOnCapacity)),
        safetyOnSurface: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(safetyOnSurface)),
        geometry: parseGeometryInput(pvs, false),
        steamState: parseSteamCoilSteamStateCalculateInput(pvs)
    };
}
function parseSteamTargetTemperatureInput(pvs) {
    const temperatureTarget = property_1.PropertyValueSet.getAmount("calculationmethodtargettemperature", pvs);
    return Object.assign(Object.assign({}, parseSteamMaxPerformanceInput(pvs)), { temperatureTarget: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(temperatureTarget)) });
}
function parseExpressCalcPressureSteamMaxPerformanceInputs(pvs) {
    const temperatureIn = property_1.PropertyValueSet.getAmount("airinputstemperature", pvs);
    const pressureIn = property_1.PropertyValueSet.getAmount("airinputspressure", pvs);
    const humidityIn = calculations_1.Physics.RP1485.AmountConversions.relativeHumidityToHumidityRatio(pressureIn, temperatureIn, property_1.PropertyValueSet.getAmount("airinputshumidity", pvs));
    const flow = property_1.PropertyValueSet.getAmount("airinputsairflow", pvs);
    const safetyOnSurface = property_1.PropertyValueSet.getAmount("safetyonsurface", pvs);
    const safetyOnCapacity = property_1.PropertyValueSet.getAmount("safetyoncapacity", pvs);
    const steamPressures = (0, functions_1.getSteamPressures)(pvs);
    const inputs = steamPressures.map((s) => ({
        temperatureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(temperatureIn)),
        humidityIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(humidityIn)),
        pressureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(pressureIn)),
        flowIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(flow)),
        safetyOnCapacity: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(safetyOnCapacity)),
        safetyOnSurface: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(safetyOnSurface)),
        geometry: parseGeometryInput(pvs, false),
        steamState: parseSteamCoilSteamStateCalculateInput(property_1.PropertyValueSet.setAmount("pressure", s, pvs))
    }));
    return inputs;
}
function parseExpressCalcTemperatureSteamMaxPerformanceInputs(pvs) {
    const pressureIn = property_1.PropertyValueSet.getAmount("airinputspressure", pvs);
    const flow = property_1.PropertyValueSet.getAmount("airinputsairflow", pvs);
    const safetyOnSurface = property_1.PropertyValueSet.getAmount("safetyonsurface", pvs);
    const safetyOnCapacity = property_1.PropertyValueSet.getAmount("safetyoncapacity", pvs);
    const inputTemperatures = (0, functions_1.getInputTemperatures)(pvs);
    const inputs = inputTemperatures.map((t) => ({
        temperatureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(t)),
        humidityIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(calculations_1.Physics.RP1485.AmountConversions.relativeHumidityToHumidityRatio(pressureIn, t, property_1.PropertyValueSet.getAmount("airinputshumidity", pvs)))),
        pressureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(pressureIn)),
        flowIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(flow)),
        safetyOnCapacity: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(safetyOnCapacity)),
        safetyOnSurface: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(safetyOnSurface)),
        geometry: parseGeometryInput(pvs, false),
        steamState: parseSteamCoilSteamStateCalculateInput(pvs)
    }));
    return inputs;
}
function parseExpressCalcHumiditySteamMaxPerformanceInputs(pvs) {
    const temperatureIn = property_1.PropertyValueSet.getAmount("airinputstemperature", pvs);
    const pressureIn = property_1.PropertyValueSet.getAmount("airinputspressure", pvs);
    const flow = property_1.PropertyValueSet.getAmount("airinputsairflow", pvs);
    const safetyOnSurface = property_1.PropertyValueSet.getAmount("safetyonsurface", pvs);
    const safetyOnCapacity = property_1.PropertyValueSet.getAmount("safetyoncapacity", pvs);
    const inputHumidities = (0, functions_1.getInputHumidities)(pvs);
    const inputs = inputHumidities.map((h) => ({
        temperatureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(temperatureIn)),
        humidityIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(calculations_1.Physics.RP1485.AmountConversions.relativeHumidityToHumidityRatio(pressureIn, temperatureIn, h))),
        pressureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(pressureIn)),
        flowIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(flow)),
        safetyOnCapacity: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(safetyOnCapacity)),
        safetyOnSurface: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(safetyOnSurface)),
        geometry: parseGeometryInput(pvs, false),
        steamState: parseSteamCoilSteamStateCalculateInput(pvs)
    }));
    return inputs;
}
function parseExpressCalcPressureSteamTargetTemperatureInput(pvs) {
    const temperatureTarget = property_1.PropertyValueSet.getAmount("calculationmethodtargettemperature", pvs);
    return parseExpressCalcPressureSteamMaxPerformanceInputs(pvs).map((i) => (Object.assign(Object.assign({}, i), { temperatureTarget: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(temperatureTarget)) })));
}
function parseExpressCalcTemperatureSteamTargetTemperatureInput(pvs) {
    const temperatureTarget = property_1.PropertyValueSet.getAmount("calculationmethodtargettemperature", pvs);
    return parseExpressCalcTemperatureSteamMaxPerformanceInputs(pvs).map((i) => (Object.assign(Object.assign({}, i), { temperatureTarget: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(temperatureTarget)) })));
}
function parseExpressCalcHumiditySteamTargetTemperatureInput(pvs) {
    const temperatureTarget = property_1.PropertyValueSet.getAmount("calculationmethodtargettemperature", pvs);
    return parseExpressCalcHumiditySteamMaxPerformanceInputs(pvs).map((i) => (Object.assign(Object.assign({}, i), { temperatureTarget: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(temperatureTarget)) })));
}
function parseTubeInput(pvs) {
    const tubeMaterialType = property_1.PropertyValueSet.getInteger("tubesmaterial", pvs);
    const thermalConductivity = property_1.PropertyValue.toString(property_1.PropertyValueSet.get("tubesconductivity", pvs));
    const tubeExternalDiameter = property_1.PropertyValue.toString(property_1.PropertyValueSet.get("tubesexternaldiameter", pvs));
    const tubeThickness = property_1.PropertyValue.toString(property_1.PropertyValueSet.get("tubesthickness", pvs));
    return {
        materialThermalConductivity: thermalConductivity,
        materialType: tubeMaterialType,
        thickness: tubeThickness,
        externalDiameter: tubeExternalDiameter,
        fouling: uom_1.Amount.valueAs(uom_1.Units.One, property_1.PropertyValueSet.getAmount("tubesfouling", pvs))
    };
}
function parseFinInput(pvs) {
    return {
        materialThermalConductivity: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("finsconductivity", pvs)),
        thickness: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("finsthickness", pvs)),
        fouling: uom_1.Amount.valueAs(uom_1.Units.One, property_1.PropertyValueSet.getAmount("finsfouling", pvs))
    };
}
function parseCoeffInput(pvs) {
    return {
        aDry: uom_1.Amount.valueAs(uom_1.Units.One, property_1.PropertyValueSet.getAmount("coefficientsadry", pvs)),
        bDry: uom_1.Amount.valueAs(uom_1.Units.One, property_1.PropertyValueSet.getAmount("coefficientsbdry", pvs)),
        cDry: uom_1.Amount.valueAs(uom_1.Units.One, property_1.PropertyValueSet.getAmount("coefficientscdry", pvs)),
        dDry: uom_1.Amount.valueAs(uom_1.Units.One, property_1.PropertyValueSet.getAmount("coefficientsddry", pvs)),
        aWet: uom_1.Amount.valueAs(uom_1.Units.One, property_1.PropertyValueSet.getAmount("coefficientsawet", pvs)),
        bWet: uom_1.Amount.valueAs(uom_1.Units.One, property_1.PropertyValueSet.getAmount("coefficientsbwet", pvs)),
        cWet: uom_1.Amount.valueAs(uom_1.Units.One, property_1.PropertyValueSet.getAmount("coefficientscwet", pvs)),
        dWet: uom_1.Amount.valueAs(uom_1.Units.One, property_1.PropertyValueSet.getAmount("coefficientsdwet", pvs))
    };
}
function parseCollectorInput(pvs, inlet) {
    return {
        materialType: property_1.PropertyValueSet.getInteger(inlet ? "inletcollectormaterialtype" : "outletcollectormaterialtype", pvs),
        quantity: property_1.PropertyValueSet.getInteger(inlet ? "inletcollectornrofcollectors" : "outletcollectornrofcollectors", pvs),
        thickness: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(inlet ? "inletcollectorthickness" : "outletcollectorthickness", pvs)),
        diameter: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(inlet ? "inletcollectordiameter" : "outletcollectordiameter", pvs))
    };
}
function parseHeaderInput(pvs, inlet) {
    return {
        materialType: property_1.PropertyValueSet.getInteger(inlet ? "inletheadermaterialtype" : "outletheadermaterialtype", pvs),
        quantity: property_1.PropertyValueSet.getInteger(inlet ? "inletheadernrofheaders" : "outletheadernrofheaders", pvs),
        thickness: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(inlet ? "inletheaderthickness" : "outletheaderthickness", pvs)),
        diameter: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(inlet ? "inletheaderdiameter" : "outletheaderdiameter", pvs))
    };
}
function parseGeometryInput(pvs, fluidCoil) {
    return {
        tubes: uom_1.Amount.valueAs(uom_1.Units.One, property_1.PropertyValueSet.getAmount("coiltubesinheight", pvs)),
        circuits: uom_1.Amount.valueAs(uom_1.Units.One, property_1.PropertyValueSet.getAmount("coilcircuits", pvs)),
        rows: property_1.PropertyValueSet.getInteger("coilrows", pvs),
        finSpacing: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("coilfinspacing", pvs)),
        tubeLength: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("coiltubelength", pvs)),
        tube: parseTubeInput(pvs),
        fin: parseFinInput(pvs),
        coeffInput: parseCoeffInput(pvs),
        distanceBetweenRows: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("coildistbtwrows", pvs)),
        distanceBetweenTubes: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("coildistbtwtubes", pvs)),
        connectionSide: property_1.PropertyValueSet.getInteger("coilconnectionside", pvs),
        exchangerFlow: property_1.PropertyValueSet.getInteger("coilexchangerflowtype", pvs),
        staggered: property_1.PropertyValueSet.getInteger("coilstaggered", pvs) !== 0,
        inletCollector: parseCollectorInput(pvs, true),
        outletCollector: parseCollectorInput(pvs, false),
        inletHeader: fluidCoil ? parseHeaderInput(pvs, true) : undefined,
        outletHeader: fluidCoil ? parseHeaderInput(pvs, false) : undefined
    };
}
function parseFluidInputCalculateInput(pvs) {
    const fluidFlow = property_1.PropertyValue.toString(property_1.PropertyValueSet.get("flow", pvs));
    return {
        fluidTemperatureIn: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("temperaturein", pvs)),
        fluidTemperatureOut: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("temperatureout", pvs)),
        fluidFlow: fluidFlow,
        calculateUsingFlowAsInput: property_1.PropertyValueSet.getInteger("temperatureflow", pvs) !== 0
    };
}
function parseFluidCompositionCalculateInput(pvs) {
    const glycoleType = property_1.PropertyValueSet.getInteger("antifreeze", pvs);
    return {
        glycoleType: glycoleType,
        useVolumePercentage: property_1.PropertyValueSet.getInteger("concentrationtype", pvs) !== 0,
        glycolePercentage: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(glycoleType === 0
            ? uom_1.Amount.create(0, uom_1.Units.One)
            : property_1.PropertyValueSet.getAmount("concentration", pvs)))
    };
}
function parseFreonCoilFreonStateCalculateInput(pvs) {
    return {
        evaporationTemperature: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("evaporationtemp", pvs)),
        condensingTemperature: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("condensationtemp", pvs)),
        subCooling: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("subcoolingtemp", pvs)),
        superHeat: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("superheattemp", pvs)),
        freon: property_1.PropertyValueSet.getInteger("freon", pvs)
    };
}
function parseSteamCoilSteamStateCalculateInput(pvs) {
    return {
        // A steam coil subcools condensate, not refrigerant, so it carries its own pair.
        subCooling: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("subcoolingtemp", pvs)),
        superHeat: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("superheattemp", pvs)),
        steamPressure: property_1.PropertyValue.toString(property_1.PropertyValueSet.get("pressure", pvs))
    };
}
//# sourceMappingURL=input-parser.js.map